import { apiClient, ApiClientResponse } from '../services/api-client';

export type AddressValidationStatus = 'valid' | 'suggest' | 'invalid' | 'unverified' | 'PROVIDER_ERROR';

export type AddressValidationFieldIssueCode = 'invalid';

export type AddressValidationSuggestion = {
  street?: string;
  streetNumber?: string;
  city?: string;
  psc?: string;
  state?: string;
  formattedPreview?: string;
};

export type AddressValidationRequest = {
  street: string;
  streetNumber: string;
  city: string;
  psc: string;
  state: string;
};

export type AddressValidationResponse = {
  status: AddressValidationStatus;
  fieldIssues?: Partial<Record<'psc' | 'city' | 'state', AddressValidationFieldIssueCode>>;
  suggestion?: AddressValidationSuggestion;
};

const addressValidationApi = {
  create: (payload: AddressValidationRequest): Promise<ApiClientResponse<AddressValidationResponse>> =>
    apiClient.post('/address-validation', payload),
};

export default addressValidationApi;
